module.exports = __webpack_public_path__ + "static/media/track-and-trace.eb1d834b.png";